import { FC, memo, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLazyGetFanSettingsQuery } from '../../services';
import Select from '../atom/Select';
import Input from '../atom/Input';
import { bot_fan_types } from '../../helpers/data/bot';
import { FanSectionFieldsProps, IFanSettings } from '../../models';
import type { IState } from '../../../../models';

const FanSectionFields: FC<FanSectionFieldsProps> = ({
  section,
  onFieldChange,
}) => {
  const params = useSelector((state: IState) => state.fan.fan_params);
  const [loadFanSettingsQuery] = useLazyGetFanSettingsQuery();
  const [settings, setSettings] = useState<Record<number, IFanSettings>>({
    1: {} as IFanSettings,
    2: {} as IFanSettings,
  });

  useEffect(() => {
    getSettings();
  }, []);

  const getSettings = async () => {
    const { data: plenum } = await loadFanSettingsQuery({
      type: 'plenum',
      arr: '4',
    });
    const { data: plug } = await loadFanSettingsQuery({
      type: 'plug',
      arr: '4',
    });
    if (plug && plenum) {
      setSettings({
        1: plenum,
        2: plug,
      });
    }
  };

  const wide_high = useMemo(() => {
    if (
      !section.type_id ||
      !(settings as Record<number, IFanSettings>)[section.type_id]
    )
      return { wide: [], high: [] };
    const setting = (settings as Record<number, IFanSettings>)[section.type_id];
    return {
      wide: setting.wide_arr,
      high: setting.hige_arr,
    };
  }, [settings, section.type_id]);

  return (
    <div className="bot-section__field-group">
      <div className="bot-section__field">
        <span className="text-span">with a</span>
        <Select
          name="wide"
          value={section.wide ?? ''}
          options={wide_high.wide}
          onChange={onFieldChange}
          className="bot-section__select"
          border_bottom={false}
        />
      </div>
      <div className="bot-section__field">
        <span className="text-span with-padding-left">x</span>
        <Select
          name="high"
          value={section.high ?? ''}
          options={wide_high.high}
          onChange={onFieldChange}
          className="bot-section__select"
          border_bottom={false}
        />
        <span className="text-span with-padding-right with-comma">,</span>
      </div>
      <div className="bot-section__field">
        <Select
          name="air_stream_id"
          value={section.air_stream_id ?? ''}
          options={params?.air_stream}
          onChange={onFieldChange}
          className="bot-section__select"
          isLowerCase={true}
          border_bottom={false}
          disabled
        />
        <span className="text-span with-padding-right with-comma">,</span>
      </div>
      <div className="bot-section__field">
        <Select
          name="type_id"
          value={section.type_id ?? ''}
          options={bot_fan_types}
          onChange={onFieldChange}
          className="bot-section__select"
          isLowerCase={true}
          border_bottom={false}
        />
        <span className="text-span with-padding-right">fan,</span>
      </div>
      <div className="bot-section__field">
        <span className="text-span">rated at</span>
        <Input
          name="airflow"
          min={0}
          max={400000}
          onChange={onFieldChange}
          value={section.airflow}
          autoResize
          numberSeparator
          placeholder='- -'
          type="number"
          disabled
        />
        <span className="text-span with-padding-right">CFM,</span>
      </div>
      <div className="bot-section__field">
        <Input
          name="tsp"
          min={0}
          max={16}
          onChange={onFieldChange}
          value={section.tsp}
          autoResize
          decimal={2}
          type="number"
          placeholder='- -'
        />
        <span className="text-span">in WC total static pressure</span>
      </div>
    </div>
  );
};
export default memo(FanSectionFields);
